import { primaryColor, dotColor } from 'assets/jss/material-dashboard-pro-react';
const paginateStyle = (theme) => ({
	dotsWrapper: {
		display: 'flex',
		height: '21px',
		'align-items': 'center',
		gap: '12px',
	},
	selectedDot: {
		width: '20px',
		height: '20px',
		borderRadius: '16px',
		background: primaryColor[0],
	},
	dot: {
        borderRadius: '16px',
		width: '15px',
		height: '15px',
		background: dotColor,
	},
	arrowWrapper: {
		display: 'flex',
		'align-items': 'flex-start',
		gap: '24px',
	},
	enableArrow: {
		borderRadius: '4px',
		cursor: 'pointer',
		background:
			`var(--Interaction-Blue-Secondary-Hover, linear-gradient(0deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.80) 100%), ${primaryColor[0]})`,
	},
});

export default paginateStyle;
